<nb-card>
  <nb-card-header>
    {{ label }}
  </nb-card-header>
  <nb-card-body>
    {{ 'theme.too-much-sites-dialog.text' | translate }}
  </nb-card-body>
  <nb-card-footer class="text-right">
    <button nbButton (click)="confirm()">
      {{ 'theme.too-much-sites-dialog.ok' | translate }}
    </button>
  </nb-card-footer>
</nb-card>
